import { render, staticRenderFns } from "./ModalV2.vue?vue&type=template&id=324ebf8c&scoped=true&"
import script from "./ModalV2.vue?vue&type=script&lang=ts&"
export * from "./ModalV2.vue?vue&type=script&lang=ts&"
import style0 from "./ModalV2.vue?vue&type=style&index=0&id=324ebf8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324ebf8c",
  null
  
)

export default component.exports